import {UyapRequest} from "./UyapRequest";
import {ResponseType} from "axios";

export interface GetEvrakBlobTalep {
    evrakId: number | string,
    dosyaId: string | number,
    yargiTuru: string | number,
}

export class EvrakIndir extends UyapRequest<GetEvrakBlobTalep, Blob> {
    delayTime = 2000;

    getMethod(): "POST" | "GET" {
        return 'GET';
    }

    getSpinnerMessage(){
        return "Evrak indiriliyor...";
    }

    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    async getMockResponse(): Promise<Blob> {
        try {
            let response =  await this.axios.get("http://localhost:8080/mockfile/evrak_11491180552.pdf",{responseType:"blob"})
            return response.data;
        } catch (error) {
            return new Blob();
            console.warn("EvrakIndir mock pdf yuklenemedi", error);
        }
        return new Blob();
    }

    getResponseType(): ResponseType {
        return 'blob';
    }

    getUrl(): string {
        return this.ImzaClientAddr + `download_document_brd.uyap`;//?evrakId=`+this.talepData.evrakId+`&dosyaId=`+this.talepData.dosyaId;
    }

    async parse(data: Blob): Promise<Blob> {
        return data;
    }
}

export default EvrakIndir;
